module.exports = __webpack_public_path__ + "img/kyc.bc6a871.png";